/*
 * A helper function to get the configuration from the backend
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { HttpClient } from '@angular/common/http';
import {ConfigurationService} from 'app/shared/services/configuration.service';

export function initApp(http: HttpClient, configService: ConfigurationService) {
  return () => {
    return configService.loadConfiguration();
  };
}
